export class Movie {
    id: number;
    name: string;
    type: string;
    poster_location: string;
}